import { createStore } from '@/utils/createStore'
import { AllocationStatus } from '@/types'

export interface ConsumerAlloc {
  id: string
  name: string
  allocatedUnits: number
  // Shakthi Power Tariff is no longer set by Unit Allocation — it's resolved
  // live from Tariff Master at approval/invoice time (see tariffResolver.ts,
  // AllocationList's reconcileTariffs). Optional so legacy rows saved before
  // this changed still decode fine.
  tariff?: number
  // ── Full per-consumer detail (added so editing an allocation doesn't
  // silently collapse share%/consumption/reading-link data — see
  // AllocationForm's buildRecord()/edit-prefill). Optional so legacy rows
  // saved before this field existed still decode fine. ──
  share?: number
  slots?: { slotName: string; units: number }[]
  consumption?: { slotName: string; units: number }[]
  readingId?: string
}

export interface MockAllocation {
  id: string
  generatorId: string
  generatorName: string
  // ── Plant (a generator can have multiple plants — which one this allocation is for) ──
  plantId?: string
  plantName?: string
  meterReadingId: string
  period: string
  consumerCount: number
  totalGenerated: number
  totalAllocated: number
  tdLoss: number
  // The T&D-loss % actually entered on the form, persisted as-is. Optional
  // for legacy rows saved before this column existed (see the "tdLoss" field
  // above, which is really just totalGenerated-totalAllocated, not a real
  // loss % — never back-derive tdLossPct from it, that's what corrupted the
  // over-allocation check on re-edit).
  tdLossPct?: number
  // Per-slot generation breakdown, same shape as meter_readings.slots.
  // Optional for legacy rows saved before this column existed.
  generationSlots?: { slotName: string; units: number }[]
  status: AllocationStatus
  submittedBy: string
  submittedAt: string
  approvedBy?: string
  approvedAt?: string
  rejectionReason?: string
  generatorTariff?: number
  consumerAllocations?: ConsumerAlloc[]
}

export const allocationStore = createStore<MockAllocation>('sp_allocations', [], 'UA', 4, '/allocations')
